import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetCsvExcelAccountsRequestModel, GetCsvExcelAccountsResponseModel } from "@/features/accounts/csv-excel/services/get-accounts-model";

export class GetCsvExcelAccountsApi {
  /**
   * CsvExcel一覧取得API
   */
  public getCsvExcelAccounts = async (
    param: GetCsvExcelAccountsRequestModel
  ): Promise<GetCsvExcelAccountsResponseModel[]> => {
    const path = `/api/csvexcelaccounts`;
    const res = await ApiClient.instance.get<GetCsvExcelAccountsResponseModel[]>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
